export default __webpack_public_path__ + "static/media/mafaldabet_receipt.46ac1212.jpg";